import { LockIcon } from "@chakra-ui/icons";
import { Flex, Text, Icon, useColorModeValue, IconProps, Tooltip } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconType } from "react-icons";

export const NavbarItem = ({ 
  text, 
  href, 
  disabled,
  icon,
  isCollapsed = false 
}: { 
  text: string, 
  href: string; 
  icon: IconType;
  disabled: boolean;
  isCollapsed?: boolean;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const IconComponent = icon;

  const isActive = location.pathname.startsWith(href);
  const activeBg = useColorModeValue("#61a6fa", "#61a6fa");
  const hoverBg = useColorModeValue("#f4f4f5", "#f4f4f5");
  const textColor = useColorModeValue("#3f3f46", "#3f3f46");
  const activeTextColor = useColorModeValue("white", "white");

  return (
    <Tooltip 
      label={text} 
      placement="right" 
      isDisabled={!isCollapsed}
      hasArrow
    >
      <Flex
        as="a"
        href={disabled ? undefined : href}
        w="100%"
        h="32px"
        alignItems="center"
        borderRadius="6px"
        transition="all 0.2s ease"
        sx={{
          backgroundColor: isActive ? activeBg : "transparent",
          "&:hover": {
            opacity: disabled ? 1 : 0.8,
            cursor: disabled ? "default" : "pointer"
          },
          textDecoration: "none"
        }}
        onClick={(e) => {
          if (!disabled) {
            e.preventDefault();
            navigate(href);
          }
        }}
      >
        {IconComponent && (
          <Icon
            as={IconComponent as React.ComponentType<IconProps>}
            mr={isCollapsed ? 0 : 3}
            ml={"8px"}
            color={isActive ? activeTextColor : textColor}
            opacity={disabled ? 0.5 : 1}
          />
        )}
        {!isCollapsed && (
          <Text
            fontSize="14px"
            lineHeight="20px"
            padding="8px 12px 8px 0"
            color={isActive ? activeTextColor : textColor}
            letterSpacing="0.5px"
            fontWeight={isActive ? 600 : 500}
            opacity={disabled ? 0.5 : 1}
          >
            {text}
          </Text>
        )}
        {disabled && !isCollapsed && <LockIcon color="blue.400" ml="auto" mr={4} />}
      </Flex>
    </Tooltip>
  );
};
